module.exports = __webpack_public_path__ + "static/media/DIVORCIO MATRIMONIO CIVIL CON HIJOS MENOR v1.148a6ebf.pdf";